<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <div class="page-title">{{ dealer_name }} ({{ dealer_code }})</div>
                <div class="btn-groups pull-right">
                    <router-link title="Update Dealer Account" class="btn btn-primary" v-if="canAddCustomer"
                        v-bind:to="{ name: 'CustomerEdit', params: { id: $route.params.id } }">
                        <i class="fp-edit-icon"> </i> Update
                    </router-link>
                    <button type="submit" class="btn btn-secondary"
                        v-on:click.prevent="goToGetLogInfo($route.params.id)">
                        Action Log
                    </button>
                    <button type="submit" class="btn btn-secondary" v-on:click.prevent="backButton">
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
            </div>
            <div class="container-fluid">
                <div id="customer-detail" class="admin-page-content customer-view list-view">
                    <!--Print Backend Error message-->
                    <section class="internal-container border-top-table-fl">
                        <h4 style="padding-left: 10px;">Dealer Account</h4>
                        <div class="form-row section-divider">
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">Dealer Code:</label>
                                    <span class="col"> {{ dealer_code }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Bill Cus Id:</label>
                                    <span class="col">{{ bill_cus_id }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col"> Dealer Name:</label>
                                    <span class="col"> {{ dealer_name }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col"> Dealer Legacy Code:</label>
                                    <span class="col"> {{ old_customer_code }} </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col"> Dealer Group Name:</label>
                                    <span class="col"> {{ dealer_group_name }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Account Status:</label>
                                    <span class="col"> {{ titleCase(account_status) }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Account Creation Date:</label>
                                    <span class="col"> {{ account_creation_date }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Stage:</label>
                                    <span class="col"> {{ stage }} </span>
                                </div>
                            </div>
                        </div>

                        <h4 style="padding-left: 10px;">Billing</h4>
                        <div class="form-row section-divider">
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">Address:</label>
                                    <span class="col"> {{ billing_address }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">City:</label>
                                    <span class="col"> {{ city }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">{{state_province}}:</label>
                                    <span class="col"> {{ state }} </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">{{zip_postal}}:</label>
                                    <span class="col"> {{ zip_code }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Company Name:</label>
                                    <span class="col"> {{ billing_company_name }} </span>
                                </div>
                            </div>
                        </div>

                        <h4 style="padding-left: 10px;">Ship To</h4>
                        <div class="form-row section-divider">
                            <div class="table-responsive-sm mt-2" style="padding-left: 15px; padding-right: 15px;">
                                <table class="table table-bordered table-sm" style="table-layout: fixed;">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Company Name</th>
                                            <th scope="col">Address</th>
                                            <th scope="col">{{state_province}}</th>
                                            <th scope="col">City</th>
                                            <th scope="col">{{zip_postal}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="shipToRows.length > 0">
                                            <template v-for="(row, index) in shipToRows">
                                                <tr>
                                                    <td>{{ row.company_name }}</td>
                                                    <td>{{ row.address }}</td>
                                                    <td>{{ row.state_id }}</td>
                                                    <td>{{ row.city }}</td>
                                                    <td>{{ row.zipcode }}</td>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <h4 style="padding-left: 10px;">Dealer Pro Admin</h4>
                        <div class="form-row section-divider">
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">Name:</label>
                                    <span class="col"> {{ name }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Title:</label>
                                    <span class="col"> {{ title }} </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">Email:</label>
                                    <span class="col"> {{ email }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Phone:</label>
                                    <span class="col"> {{ phone }} </span>
                                </div>
                            </div>
                        </div>

                        <h4 style="padding-left: 10px;">Rates</h4>
                        <div class="form-row section-divider">
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">Approved Warranty {{ labor_spelling }} Rate:</label>
                                    <span class="col"> {{ approved_labor_rate }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Date of Last Change:</label>
                                    <span class="col"> {{ labor_last_change_date }} </span>
                                </div>
                            </div>
                            <div class="col-md-6">

                                <div class="row form-group">
                                    <label class="col">Approved Travel Rate (Time):</label>
                                    <span class="col"> {{ approved_time_travel_rate }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Date of Last Change (Time):</label>
                                    <span class="col"> {{ time_travel_last_change_date }} </span>
                                </div>

                                <div class="row form-group">
                                    <label class="col">Approved Travel Rate (Distance):</label>
                                    <span class="col"> {{ approved_distance_travel_rate }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Date of Last Change (Distance):</label>
                                    <span class="col"> {{ distance_travel_last_change_date }} </span>
                                </div>
                            </div>
                        </div>

                        <h4 style="padding-left: 10px;">Primary Contacts</h4>
                        <div class="form-row section-divider">
                            <div class="table-responsive-sm mt-2" style="padding-left: 15px; padding-right: 15px;">
                                <table class="table table-bordered table-sm" style="table-layout: fixed;">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Contact Type</th>
                                            <th scope="col">Name</th>
                                            <th scope="col">Email</th>
                                            <th scope="col">Phone</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="primaryContactRows.length > 0">
                                            <template v-for="(row, index) in primaryContactRows">
                                                <tr>
                                                    <td>{{ row.contact_type }}</td>
                                                    <td>{{ row.contact_name }}</td>
                                                    <td>{{ row.contact_email }}</td>
                                                    <td>{{ row.contact_phone }}</td>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <h4 style="padding-left: 10px;">Invoice Delivery</h4>
                        <div class="form-row section-divider">
                            <div class="col-md-6">
                                <div class="row form-group">
                                    <label class="col">Invoice/Credit Memo Delivery Email:</label>
                                    <span class="col"> {{ invoice_delivery_email }} </span>
                                </div>
                            </div>
                        </div>

                        <h4 style="padding-left: 10px;">Documents</h4>
                        <div class="form-row section-divider">
                            <div class="table-responsive-sm mt-2" style="padding-left: 15px; padding-right: 15px;">
                                <table class="table table-bordered table-sm" style="table-layout: fixed;">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Document Type</th>
                                            <th scope="col">File</th>
                                            <th scope="col" style="width: 15%;">Uploaded Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="documentRows.length > 0">
                                            <template v-for="(row, index) in documentRows">
                                                <tr>
                                                    <td>{{ row.document_type }}</td>
                                                    <td>
                                                        <a v-if="(row.file_link != '' && row.file_link != null)"
                                                            v-on:click="goToGetDocumentPath($event, row.file_link)"
                                                            title="View Dealer Document" href="javascript:void(0);"
                                                            style="font-size: 15px;">
                                                            <i class="fp-text-document"></i> Attached
                                                            File
                                                        </a>
                                                    </td>
                                                    <td>
                                                        {{ row.uploaded_date }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <h4 style="padding-left: 10px;">Software</h4>
                        <div class="form-row section-divider">
                            <div class="table-responsive-sm mt-2" style="padding-left: 15px; padding-right: 15px;">
                                <table class="table table-bordered table-sm" style="table-layout: fixed;">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Software Name</th>
                                            <th scope="col">Start Date</th>
                                            <th scope="col">Exp Date</th>
                                            <th scope="col">Invoice #</th>
                                            <th scope="col">Admin Name</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-if="softwareRows.length > 0">
                                            <template v-for="(row, index) in softwareRows">
                                                <tr>
                                                    <td>{{ row.software_name }}</td>
                                                    <td>{{ row.start_date }}</td>
                                                    <td>{{ row.exp_date }}</td>
                                                    <td>{{ row.invoice_number }}</td>
                                                    <td>{{ row.admin_name }}</td>
                                                </tr>
                                            </template>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <h4 style="padding-left: 10px;">RIZON Representative</h4>
                        <div class="form-row section-divider">
                            <div class="col-md-6">
                                <b>Truck Sales Person</b>
                                <div class="row form-group">
                                    <label class="col">Name:</label>
                                    <span class="col"> {{ truck_sales_person_name }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Email:</label>
                                    <span class="col"> {{ truck_sales_person_email }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Assigned Date:</label>
                                    <span class="col"> {{ truck_sales_person_assigned_date }} </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <b>Product Support Manager</b>
                                <div class="row form-group">
                                    <label class="col">Name:</label>
                                    <span class="col"> {{ product_support_manager_name }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Email:</label>
                                    <span class="col"> {{ product_support_manager_email }} </span>
                                </div>
                                <div class="row form-group">
                                    <label class="col">Assigned Date:</label>
                                    <span class="col"> {{ product_support_manager_assigned_date }} </span>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
            </div>

            <audit-log-popup :logs="logs" :popUpTitle="popUpTitle"></audit-log-popup>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>

    </div>

</template>
<script>
import Vue from "vue";
import { commonMixins } from '../../mixins/commonMixins';

export default {
    name: "DealerAccountView",
    components: {
        appFooter: () => import('@/components/Footer')
    },
    mixins: [commonMixins],
    data: () => ({
        loading: false,
        cantAccessPage: "",
        permissions: [],
        canAddCustomer: false,
        dealer_code: "",
        bill_cus_id: '',
        dealer_name: '',
        dealer_group_name: '',
        account_status: '',
        account_creation_date: '',
        billing_address: '',
        billing_company_name: '',
        city: '',
        state: '',
        zip_code: '',
        shipToRows: [],
        name: '',
        title: '',
        email: '',
        phone: '',
        approved_labor_rate: '',
        labor_last_change_date: '',
        approved_time_travel_rate: '',
        time_travel_last_change_date: '',
        approved_distance_travel_rate: '',
        distance_travel_last_change_date: '',
        primaryContactRows: [],
        softwareRows: [],
        invoice_delivery_email: '',
        documentRows: [],
        truck_sales_person_name: '',
        truck_sales_person_email: '',
        truck_sales_person_assigned_date: '',
        product_support_manager_name: '',
        product_support_manager_email: '',
        product_support_manager_assigned_date: '',
        popUpTitle: 'Dealer Activity Log Details',
        logs: [],
        old_customer_code: '',
        stage: ''
    }),
    watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'ev_add_dealer') {
                        self.canAddCustomer = true;
                    }
                    if (permissions[i].name == 'ev_view_dealer') {
                        self.cantAccessPage = true;
                        setTimeout(function () {
                            $('.right-asset-tab-list').on('click', 'li', function () {
                                $('.right-asset-tab-list li.active').removeClass('active');
                                $(this).addClass('active');
                            });
                        }, 200);
                        setTimeout(function () {
                            var path = window.location.pathname;
                            var segments = path.split("/");
                            if (segments[3]) {
                                self.loadDealer();
                            }
                        }, 100);
                    }
                }
            }
        },
    },
    mounted: function () {
        this.getPermissions();
    },
    metaInfo() {
        return {
            title: (this.dealer_code != "") ? this.dealer_code + " | Dealer Account | " + process.env.COPYRIGHT_NAME : "Dealer Account | " + process.env.COPYRIGHT_NAME
        }
    },
    methods: {
        loadDealer() {

            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            self.customer_id = segments[3];
            self.loading = true;


            $.ajax({
                url: process.env.ROOT_API + "/customer/" + segments[3],
                type: "GET",
                headers: this.ajxHeaders,
                data: {
                    action_flag: 'view', // pass action for notify: view, edit
                    is_notify_flag: true // notify if user viewing or editing
                },
                dataType: "json",
                success: function (data) {

                    self.loading = false;

                    if (data.status == "success") {
                        self.dealer_code = data.content.code;
                        self.bill_cus_id = data.content.pcust_code;
                        self.dealer_name = data.content.name;
                        self.dealer_group_name = data.content.dealer_group_name;
                        self.account_status = data.content.status;
                        self.account_creation_date = data.content.account_creation_date;
                        if(data.content.stage) {
                            if(data.content.stage == 'potential') {
                                self.stage = 'Pending Approval';
                            } else {
                                self.stage = self.ucString(data.content.stage);
                            }
                        }
                        self.billing_address = data.content.address_line_1;
                        self.billing_company_name = data.content.company_name;
                        self.city = data.content.city_name;
                        self.state = data.content.stateName;
                        self.zip_code = data.content.postcode;
                        self.labor_last_change_date = data.content.labor_rate_change_date;
                        self.time_travel_last_change_date = data.content.time_travel_rate_change_date;
                        self.distance_travel_last_change_date = data.content.distance_travel_rate_change_date;
                        self.primaryContactRows = data.content.customer_contacts;
                        self.softwareRows = data.content.dealer_account_softwares;
                        self.invoice_delivery_email = data.content.invoice_delivery_email;

                        self.name = data.content.dealer_pro_admin_name;
                        self.title = data.content.dealer_pro_admin_title;
                        self.email = data.content.dealer_pro_admin_email;
                        self.phone = data.content.dealer_pro_admin_phone;

                        self.truck_sales_person_name = data.content.truck_sales_person_name;
                        self.truck_sales_person_email = data.content.truck_sales_person_email;
                        self.truck_sales_person_assigned_date = data.content.truck_sales_person_assigned_date;

                        self.product_support_manager_name = data.content.product_support_manager_name;
                        self.product_support_manager_email = data.content.product_support_manager_email;
                        self.product_support_manager_assigned_date = data.content.product_support_manager_assigned_date;

                        self.approved_labor_rate = self.formatCurrency(data.content.labor_rate);
                        self.approved_time_travel_rate = self.formatCurrency(data.content.time_travel_rate);
                        self.approved_distance_travel_rate = self.formatCurrency(data.content.distance_travel_rate);
                        self.old_customer_code = data.content.old_customer_code;

                        self.populateDocumentRows(data.content.dealer_account_documents);
                        self.populateShipToLocations(data.content.dealer_account_ship_to_locations);

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR, true, 'custViewmessage')
                }
            });
        },
        goToGetDocumentPath(event, link) {
            event.preventDefault();
            var self = this;
            var path = link;
            var flag = '';
            var id = 0;
            self.getDocumentPath(id, path, flag);
        },
        populateDocumentRows(dealerAccountDocument) {
            this.documentRows = [];
            for (let i = 0; i < dealerAccountDocument.length; i++) {
                if(
                    dealerAccountDocument[i].document_type
                    &&
                    dealerAccountDocument[i].uploaded_file
                ){
                    this.documentRows.push({
                        id: dealerAccountDocument[i].id,
                        document_type: dealerAccountDocument[i].document_type,
                        file_link: (dealerAccountDocument[i].uploaded_file != "") ? dealerAccountDocument[i].uploaded_file : null,
                        dealer_id: dealerAccountDocument[i].dealer_id,
                        uploaded_date: dealerAccountDocument[i].upload_date
                    });
                }
            }
        },
        populateShipToLocations(dealerShipToRows) {
            this.shipToRows = [];
            for (let i = 0; i < dealerShipToRows.length; i++) {
                this.shipToRows.push({
                    id: dealerShipToRows[i].id,
                    company_name: dealerShipToRows[i].company_name,
                    state_id: dealerShipToRows[i].state_id.text,
                    address: dealerShipToRows[i].address,
                    city: dealerShipToRows[i].city,
                    zipcode: dealerShipToRows[i].zipcode,
                });
            }
        },
        goToGetLogInfo(logId) {
            var self = this;
            var logFlag = 'DEALERS_AUDIT';

            self.getLogInfo(logId, logFlag);
        },
        backButton() {
            var url = '/dealer/list';
            this.redirectPageUrl(url);
        },
    }
}

</script>



// WEBPACK FOOTER //
// src/components/customer/DealerAccountView.vue